<cfp-modal-content [title]="'login.title' | translate" [showCloseButton]="false">
  <ng-container modal-body>
    @if (!shouldChangePassword()) {
      <form id="loginForm" [formGroup]="form" #ngForm="ngForm" (ngSubmit)="ngForm.valid && submitForm()">
        <cfp-form-group [label]="'login.userNameOrEmail' | translate">
          <span formGroupAfterLabel class="text-primary ms-1 mandatory">*</span>
          <cfp-input-text
            [id]="'username'"
            dataTest="userName"
            [placeholder]="'login.userNameOrEmail.placeholder' | translate"
            formControlName="username"
          />
          <cfp-validation-feedback
            [showMessage]="ngForm.submitted && !isFieldValid('username')"
            [control]="form.get('username')"
            [message]="'validation.required' | translate: { name: ('login.userNameOrEmail' | translate) }"
          />
        </cfp-form-group>

        @if (shouldLoginUsingSsoOnly()) {
          <cfp-alert [alertStyle]="'info'">{{ 'login.forceSso' | translate }}</cfp-alert>
        }

        <cfp-form-group [label]="'login.password' | translate">
          <div formGroupActions>
            <cfp-link
              tabindex="-1"
              [classes]="'text-start small'"
              [dataTest]="'forgotPasswordButton'"
              (clicked)="showForgotPassword()"
              >{{ 'login.forgot' | translate }}
            </cfp-link>
          </div>
          <div class="col-12">
            <cfp-input-password
              autocomplete="current-password"
              dataTest="password"
              formControlName="password"
              [id]="'password'"
              [placeholder]="'login.password.placeholder' | translate"
            />
            <cfp-validation-feedback
              [showMessage]="ngForm.submitted && !isFieldValid('password')"
              [control]="form.get('password')"
            />
          </div>
        </cfp-form-group>
      </form>
    }
    <cfp-login-messages
      [errorMessages]="errorMessages()"
      [warningMessages]="warningMessages()"
      [interpolateParams]="interpolateParams()"
      [attr.data-test]="loginMessagesDataTest()"
    />
  </ng-container>
  <div modal-footer>
    @if (shouldChangePassword()) {
      <cfp-link
        dataTest="goToChangePasswordButton"
        [buttonStyle]="'warning'"
        [classes]="'text-start'"
        (clicked)="routePasswordChange()"
        >{{ 'login.change' | translate }}
      </cfp-link>
    } @else {
      <div>
        <div class="row">
          <div class="col-12">
            <cfp-button
              class="w-100"
              classes="w-100"
              dataTest="loginButton"
              type="submit"
              [disabled]="isLoading() || shouldLoginUsingSsoOnly()"
              [form]="'loginForm'"
            >
              @if (isLoading()) {
                <span class="spinner-grow spinner-grow-sm"></span>
              }
              {{ 'login.title' | translate }}
            </cfp-button>
          </div>
          <div class="col-12 mt-4 small">
            {{ 'login.noAccount' | translate }}
            <cfp-link [classes]="'text-start ms-1'" (clicked)="createAccountClick()"
              >{{ 'login.createAccount' | translate }}
            </cfp-link>
          </div>

          @if (showLoginUsingSso && ssoLoginUrl) {
            <div class="col-12 mt-3">
              <div class="row mx-0 px-0 justify-content-center align-items-center">
                <span class="col border-bottom w-50"></span>
                <span class="col-auto"> {{ 'login.divider.text' | translate }} </span>
                <span class="col border-bottom w-50"></span>
              </div>
            </div>

            <cfp-link
              class="mt-4"
              classes="d-flex w-100 align-items-center justify-content-center login-sso-button"
              target="_self"
              [id]="'loginSso'"
              [buttonOutline]="true"
              [buttonStyle]="'secondary'"
              [dataTest]="'loginAsRelationManager'"
              [url]="ssoLoginUrl"
            >
              <span class="mx-auto">{{ 'login.sso' | translate }}</span>
            </cfp-link>
          }
        </div>
      </div>
    }
  </div>
</cfp-modal-content>
